import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { FloorplanImageSelector } from '../atomic-components/FloorplanImageSelector';
import { PropertyPhotosImageSelector } from '../atomic-components/PropertyPhotosImageSelector';
import { LocationPhotosImageSelector } from '../atomic-components/LocationPhotosImageSelector';

export const AssetApprovalImages = () => {
  return (
    <LaunchpadCard title={'Images'}>
      <FloorplanImageSelector />
      <PropertyPhotosImageSelector />
      <LocationPhotosImageSelector />
    </LaunchpadCard>
  );
};
